export default __webpack_public_path__ + "static/cardImg1-dfec32c250dd916552a5a15a008b5306.webp";